/**
 * Rebuy embedded flag from theme.liquid (content_for_header).
 * Reads data-rebuy-embedded on <html>.
 *
 * @returns {boolean}
 */
export function isRebuyEmbedded () {
    if (typeof document === 'undefined') return false
    return document.documentElement.getAttribute('data-rebuy-embedded') === 'true'
}

if (typeof window !== 'undefined') {
    window.isRebuyEmbedded = isRebuyEmbedded
}
